import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

const Prompt = observer(class Prompt extends React.Component {
  constructor() {
    super();
    this.closeDialog = this.closeDialog.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
    this.handleOption = this.handleOption.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      reason: null,
      memo: null
    }
  }

  closeDialog(e) {
    e.preventDefault();
    this.props.store.SessionStore.closeDialog();
  }

  confirmDialog(e) {
    if(e) {
      e.preventDefault();
    }

    this.props.store.SessionStore.promptFunc();
  }

  handleOption() {
    this.setState({
      reason: this.option.value
    });

    // Set the cancellation memo to the option selected or null if it’s other
    if(this.option.value !== 'other-reason') {
      this.setState({
        memo: this.option.value
      });
    } else {
      this.setState({
        memo: null
      });
    }
  }

  handleInput() {
    // Cancel session reason
    if(this.memo) {
      this.setState({
        memo: this.memo.value || null
      });
    }

    // Export CSV prompt
    if(this.title) {
      this.props.store.ReportStore.reportExportTitle = this.title.value;
    }
  }

  handleSubmit() {
    this.props.store.SessionStore.promptSelectFunc(this.state.memo, this.state.reason);

    const _this = this;
    setTimeout(function(){
      _this.props.store.SessionStore.promptFunc();
    });
  }

  render() {
    const { SessionStore } = this.props.store;

    return(
      <div className="dialog dialog--confirm">
        <form className="dialog__content" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
          <strong className="dialog__msg" tabIndex="0">{SessionStore.promptContent.heading}</strong>

          <p>{SessionStore.promptContent.body}</p>

          {SessionStore.promptContent.options &&
            <label className="select dialog__select" htmlFor="prompt-options">
              <select
                id="prompt-options"
                onChange={this.handleOption}
                ref={(input) => {this.option = input}}
              >
                <option value='' disabled selected>Select an option...</option>
                {SessionStore.promptContent.options.map(
                  (option, i) =>
                  <option key={i} value={option.value}>{option.label}</option>
                )}
              </select>
            </label>
          }

          {(!SessionStore.promptContent.options || this.state.reason === 'other-reason') && !SessionStore.promptContent.input &&
            <textarea
              id="prompt-other"
              className="dialog__input"
              ref={(input) => {this.memo = input}}
              onChange={this.handleInput}
              required
              aria-required="true"
            ></textarea>
          }

          {SessionStore.promptContent.input &&
            <div>
              <label htmlFor="prompt-input">
                {SessionStore.promptContent.input}
              </label>

              <input
                type="text"
                id="prompt-input"
                className="dialog__input"
                defaultValue={SessionStore.promptText}
                ref={(input) => {this.title = input}}
                onChange={this.handleInput}
                required
                aria-required="true"
                placeholder={SessionStore.promptContent.input}
              />
            </div>
          }

          <div className="dialog__btns">
            <a href="#app" className="btn btn--outline" onClick={(e) => this.closeDialog(e)}>Cancel</a>
            <button
              className="btn"
              disabled={!this.state.memo && !SessionStore.promptContent.input}
            >
              {SessionStore.promptContent.button}
            </button>
          </div>
        </form>
      </div>
    );
  }
})

export default Prompt;



// WEBPACK FOOTER //
// ./src/app/components/Common/Prompt.js